(function () {
  var page = document.querySelector('[data-arq-page]');
  if (!page) return;
  var whatsappBase = 'https://wa.me/5541998821349?text=';
  function whatsappUrl(message) { return whatsappBase + encodeURIComponent(message); }

  page.querySelectorAll('[data-preset]').forEach(function (link) {
    var preset = link.getAttribute('data-preset');
    link.href = whatsappUrl('Olá, vim pela página de soluções sob medida e quero conversar sobre um projeto de ' + preset + '.');
    link.target = '_blank';
    link.rel = 'noopener';
    link.setAttribute('data-whatsapp-context', preset);
  });

  var mixtureLink = page.querySelector('[data-mixture-brief]');
  if (mixtureLink) {
    function updateMixtureLink() {
      var choice = page.querySelector('input[name="mistura-rewave"]:checked');
      var composition = choice ? choice.value : 'uma composição de placa';
      mixtureLink.href = whatsappUrl('Olá, vim pela página de soluções sob medida e quero conversar sobre a composição ' + composition + ' para um projeto.');
    }
    page.querySelectorAll('input[name="mistura-rewave"]').forEach(function (input) {
      input.addEventListener('change', updateMixtureLink);
    });
    updateMixtureLink();
  }

  page.querySelectorAll('[data-whatsapp-context]').forEach(function (link) {
    link.addEventListener('click', function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'architect_whatsapp_click', context: link.getAttribute('data-whatsapp-context') || 'geral' });
    });
  });

  page.querySelectorAll('.arq-variants').forEach(function (gallery) {
    var cards = gallery.querySelectorAll('figure');
    function activate(card) {
      gallery.classList.add('is-interacting');
      cards.forEach(function (item) { item.classList.toggle('is-active', item === card); });
    }
    function reset() {
      gallery.classList.remove('is-interacting');
      cards.forEach(function (item) { item.classList.remove('is-active'); });
    }
    cards.forEach(function (card) {
      card.tabIndex = 0;
      card.addEventListener('mouseenter', function () { activate(card); });
      card.addEventListener('click', function () {
        if (card.classList.contains('is-active')) reset();
        else activate(card);
      });
      card.addEventListener('focus', function () { activate(card); });
      card.addEventListener('blur', function () {
        if (!gallery.contains(document.activeElement)) reset();
      });
    });
    gallery.addEventListener('mouseleave', reset);
  });

  var colorMarquee = page.querySelector('.arq-color-marquee__viewport');
  if (colorMarquee) {
    var colorGroup = colorMarquee.querySelector('.arq-color-marquee__group');
    var colorCards = Array.prototype.slice.call(colorGroup.querySelectorAll('figure'));
    var colorSection = colorMarquee.closest('.arq-color-marquee');
    var colorStage = document.createElement('div');
    var colorBrowser = document.createElement('div');
    var colorFeatured = document.createElement('figure');
    var colorControls = document.createElement('div');
    var colorCounter = document.createElement('span');
    var colorPrevious = document.createElement('button');
    var colorNext = document.createElement('button');
    var colorCta = document.createElement('a');
    var colorActive = 0;
    var colorDragging = false;
    var colorMoved = false;
    var colorStartX = 0;
    var colorStartScroll = 0;

    colorStage.className = 'arq-color-gallery arq-wrap';
    colorBrowser.className = 'arq-color-gallery__browser';
    colorFeatured.className = 'arq-color-gallery__featured';
    colorFeatured.setAttribute('aria-live', 'polite');
    colorControls.className = 'arq-color-gallery__controls';
    colorCounter.className = 'arq-color-gallery__counter';
    colorPrevious.type = 'button';
    colorPrevious.className = 'arq-color-gallery__arrow';
    colorPrevious.setAttribute('aria-label', 'Composição anterior');
    colorPrevious.textContent = '←';
    colorNext.type = 'button';
    colorNext.className = 'arq-color-gallery__arrow';
    colorNext.setAttribute('aria-label', 'Próxima composição');
    colorNext.textContent = '→';
    colorCta.className = 'arq-text-link arq-color-gallery__cta';
    colorCta.target = '_blank';
    colorCta.rel = 'noopener';
    colorCta.textContent = 'Conversar sobre uma combinação de cores pelo WhatsApp →';
    colorControls.appendChild(colorCounter);
    colorControls.appendChild(colorPrevious);
    colorControls.appendChild(colorNext);
    colorBrowser.appendChild(colorControls);
    colorStage.appendChild(colorFeatured);
    colorStage.appendChild(colorBrowser);
    colorSection.insertBefore(colorStage, colorMarquee);
    colorBrowser.appendChild(colorMarquee);
    colorBrowser.appendChild(colorCta);

    function activateColor(index, reveal) {
      colorActive = (index + colorCards.length) % colorCards.length;
      var card = colorCards[colorActive];
      var source = card.querySelector('img');
      var label = card.querySelector('figcaption').textContent.trim();
      colorFeatured.innerHTML = '';
      var featuredImage = document.createElement('img');
      var featuredCaption = document.createElement('figcaption');
      featuredImage.src = source.currentSrc || source.src;
      featuredImage.alt = source.alt;
      featuredImage.width = source.width;
      featuredImage.height = source.height;
      featuredImage.loading = 'eager';
      featuredCaption.innerHTML = '<strong>' + label + '</strong><small>Referência de composição. Cores e proporções podem ser personalizadas.</small>';
      colorFeatured.appendChild(featuredImage);
      colorFeatured.appendChild(featuredCaption);
      colorCounter.textContent = String(colorActive + 1).padStart(2, '0') + ' / ' + String(colorCards.length).padStart(2, '0');
      colorCta.href = whatsappUrl('Olá, vim pela página de soluções sob medida e quero conversar sobre combinações de cores. Gostei desta referência: ' + label + '.');
      colorCards.forEach(function (item, itemIndex) {
        item.classList.toggle('is-selected', itemIndex === colorActive);
        item.setAttribute('aria-selected', itemIndex === colorActive ? 'true' : 'false');
      });
      if (reveal) card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    colorCards.forEach(function (card, index) {
      card.tabIndex = 0;
      card.setAttribute('role', 'option');
      card.addEventListener('click', function () { if (!colorMoved) activateColor(index, false); });
      card.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        activateColor(index, true);
      });
      var image = card.querySelector('img');
      image.draggable = false;
    });
    colorPrevious.addEventListener('click', function () { activateColor(colorActive - 1, true); });
    colorNext.addEventListener('click', function () { activateColor(colorActive + 1, true); });
    colorCta.addEventListener('click', function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'architect_whatsapp_click', context: 'composicao_cor' });
    });
    if (window.matchMedia('(pointer: fine)').matches) {
      colorMarquee.addEventListener('pointerdown', function (event) {
        colorDragging = true;
        colorMoved = false;
        colorStartX = event.clientX;
        colorStartScroll = colorMarquee.scrollLeft;
        colorMarquee.classList.add('is-dragging');
        colorMarquee.setPointerCapture(event.pointerId);
      });
      colorMarquee.addEventListener('pointermove', function (event) {
        if (!colorDragging) return;
        var distance = event.clientX - colorStartX;
        if (Math.abs(distance) > 5) colorMoved = true;
        colorMarquee.scrollLeft = colorStartScroll - distance;
      });
      function finishColorGalleryDrag(event) {
        if (!colorDragging) return;
        colorDragging = false;
        colorMarquee.classList.remove('is-dragging');
        if (colorMarquee.hasPointerCapture && colorMarquee.hasPointerCapture(event.pointerId)) colorMarquee.releasePointerCapture(event.pointerId);
        window.setTimeout(function () { colorMoved = false; }, 0);
      }
      colorMarquee.addEventListener('pointerup', finishColorGalleryDrag);
      colorMarquee.addEventListener('pointercancel', finishColorGalleryDrag);
    }
    colorMarquee.setAttribute('role', 'listbox');
    activateColor(0, false);
  }
})();
